import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import WidgetCard from './WidgetCard';
import { HomeNavigationContext } from './HomeNavigationContext';
import usePermissions from '../../../utils/usePermissions';
import { ADMIN_START_PAGES, getMissingStartPagePerms } from '../../../config/startPages';

const ACCENT = '#475569';

/** Какие страницы из каталога стартовых страниц выводить как быстрые ссылки (порядок = порядок вывода) */
const QUICK_LINK_KEYS = [
  'reports.fill', 'reports.summary', 'reports.director', 'documents.invoices', 'journal',
  'guide.remains', 'guide.nomenclature', 'users', 'tables'
];

/**
 * Виджет «Быстрые ссылки» (/admin): переходы на разделы. Ссылка показывается только при наличии прав на страницу
 * (перечень `requires` из каталога стартовых страниц). Право на сам виджет: home.quick_links.view
 */
const QuickLinksWidget: React.FC = () => {
  const navigate = useContext(HomeNavigationContext);
  const { hasPerm } = usePermissions();
  const links = QUICK_LINK_KEYS
    .map(key => ADMIN_START_PAGES.find(p => p.key === key))
    .filter((p): p is NonNullable<typeof p> => Boolean(p) && getMissingStartPagePerms(p as NonNullable<typeof p>, hasPerm).length === 0);

  return (
    <WidgetCard title="Быстрые ссылки" icon={<BoltOutlinedIcon />} accent={ACCENT}>
      {links.length === 0 ? (
        <Typography sx={{ p: 2, fontSize: 13, color: '#94a3b8' }}>Нет доступных разделов</Typography>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, p: 2 }}>
          {links.map(l => (
            <Box
              key={l.key}
              role="button"
              tabIndex={0}
              onClick={() => navigate && navigate(l.index, l.module)}
              onKeyDown={e => { if (e.key === 'Enter' && navigate) navigate(l.index, l.module); }}
              sx={{
                px: 1.5, py: 0.75, borderRadius: '9px', border: '1px solid #e2e8f0', bgcolor: '#f8fafc',
                fontSize: 13, color: '#0f172a', cursor: 'pointer', userSelect: 'none',
                '&:hover': { bgcolor: '#f1f5f9', borderColor: '#cbd5e1' }
              }}
            >
              {l.label.replace(/^[^→]*→\s*/, '')}
              <Typography component="span" sx={{ fontSize: 11.5, color: '#94a3b8', ml: 0.75 }}>{l.group}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </WidgetCard>
  );
};

export default QuickLinksWidget;
